import { usePartnerId } from '@retailer-platform/dashboard/routing'
import { useCreateHref } from './domain/routing'

export interface CreateHrefAccountManagementSearchPageProps {
  email: string
}

export const useCreateHrefAccountManagementSearchPage = (
  props: CreateHrefAccountManagementSearchPageProps
) => {
  const partnerId = usePartnerId({ throwOnMissing: false })
  const editAccountPath = partnerId
    ? 'partner-account-management-list'
    : 'app-admin-account-management-list'

  const href = useCreateHref(editAccountPath, null, {
    email: props.email,
  })

  return href
}
